export const SAVE_CANDIDATE_DATA = 'save_candidate_data';
